/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityarchetypedescriptionjester3Inputs */



/**
* | output |
* | --- |
* | "You’re the main anti‑stress in any group. You love breaking the tension with jokes, dropping memes, and making things feel light and fun for everyone around ..." |
*
* @param {Personalityarchetypedescriptionjester3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityarchetypedescriptionjester3 = /** @type {((inputs?: Personalityarchetypedescriptionjester3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityarchetypedescriptionjester3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("You’re the main anti‑stress in any group. You love breaking the tension with jokes, dropping memes, and making things feel light and fun for everyone around you.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eres el principal antiestrés de cualquier grupo. Te encanta romper la tensión con bromas, mandar memes y hacer que las cosas se sientan ligeras y divertidas para todos.")
	return /** @type {LocalizedString} */ ("Ты — главный антистресс в любой компании. Тебе нравится разряжать обстановку шутками, кидать мемы и делать так, чтобы всем вокруг было легко и весело.")
});
export { personalityarchetypedescriptionjester3 as "personalityArchetypeDescriptionJester" }